import batman_sm_jpg from '../images/batman@sm.jpg';
import batman_md_jpg from '../images/batman@md.jpg';
import batman_lg_jpg from '../images/batman@lg.jpg';
import batman_xl_jpg from '../images/batman@xl.jpg';

import career_areas_sm_png from '../images/career-areas-mobile@sm.png';
import career_areas_md_png from '../images/career-areas-mobile@md.png';
import career_areas_lg_png from '../images/career-areas-mobile@lg.png';
import career_areas_xl_png from '../images/career-areas-mobile@xl.png';

import careers_screens_sm_png from '../images/careers_screens@sm.png';
import careers_screens_md_png from '../images/careers_screens@md.png';
import careers_screens_lg_png from '../images/careers_screens@lg.png';
import careers_screens_xl_png from '../images/careers_screens@xl.png';

import comboSmash_highScores_xs_jpg from '../images/comboSmash-highScores@xs.jpg';
import comboSmash_highScores_md_jpg from '../images/comboSmash-highScores@md.jpg';
import comboSmash_highScores_lg_jpg from '../images/comboSmash-highScores@lg.jpg';

import comboSmash_gameplay_xs_gif from '../images/combosmash-gameplay@xs.gif';
import comboSmash_gameplay_md_gif from '../images/combosmash-gameplay@md.gif';
import comboSmash_gameplay_lg_gif from '../images/combosmash-gameplay@lg.gif';

import comboSmash_horde_sm_jpg from '../images/comboSmash-horde@sm.jpg';
import comboSmash_horde_md_jpg from '../images/comboSmash-horde@md.jpg';
import comboSmash_horde_lg_jpg from '../images/comboSmash-horde@lg.jpg';

import comboSmash_preview_xs_jpg from '../images/comboSmash-preview@xs.jpg';
import comboSmash_preview_sm_jpg from '../images/comboSmash-preview@sm.jpg';
import comboSmash_preview_md_jpg from '../images/comboSmash-preview@md.jpg';
import comboSmash_preview_lg_jpg from '../images/comboSmash-preview@lg.jpg';

import cycles_sm_jpg from '../images/cyclesTile@sm.jpg';
import cycles_md_jpg from '../images/cyclesTile@md.jpg';
import cycles_lg_jpg from '../images/cyclesTile@lg.jpg';

import cycles_gameover_sm_jpg from '../images/cycles-games-over@sm.jpg';
import cycles_gameover_md_jpg from '../images/cycles-games-over@md.jpg';
import cycles_gameover_lg_jpg from '../images/cycles-games-over@lg.jpg';

import cycles_gameplay_xs_gif from '../images/cycles-gameplay@xs.gif';
import cycles_gameplay_md_gif from '../images/cycles-gameplay@md.gif';
import cycles_gameplay_lg_gif from '../images/cycles-gameplay@lg.gif';

import cycles_start_xs_jpg from '../images/cycles-start@xs.jpg';
import cycles_start_md_jpg from '../images/cycles-start@md.jpg';
import cycles_start_lg_jpg from '../images/cycles-start@lg.jpg';

import excellusbcbs_app_page_xs_jpg from '../images/excellusbcbs-app-page@xs.jpg';
import excellusbcbs_app_page_sm_jpg from '../images/excellusbcbs-app-page@sm.jpg';
import excellusbcbs_app_page_md_jpg from '../images/excellusbcbs-app-page@md.jpg';
import excellusbcbs_app_page_lg_jpg from '../images/excellusbcbs-app-page@lg.jpg';

import excellusbcbs_careers_calendar_xs_png from '../images/excellusbcbs-careers-calendar@xs.png';
import excellusbcbs_careers_calendar_sm_png from '../images/excellusbcbs-careers-calendar@sm.png';
import excellusbcbs_careers_calendar_md_png from '../images/excellusbcbs-careers-calendar@md.png';
import excellusbcbs_careers_calendar_lg_png from '../images/excellusbcbs-careers-calendar@lg.png';

import excellusbcbs_home_viewports_xs_png from '../images/excellusbcbs-home-viewports@xs.png';
import excellusbcbs_home_viewports_md_png from '../images/excellusbcbs-home-viewports@md.png';
import excellusbcbs_home_viewports_lg_png from '../images/excellusbcbs-home-viewports@lg.png';

import excellusbcbs_member_xs_jpg from '../images/excellusbcbs-member@xs.jpg';
import excellusbcbs_member_md_jpg from '../images/excellusbcbs-member@md.jpg';
import excellusbcbs_member_lg_jpg from '../images/excellusbcbs-member@lg.jpg';

import excellusbcbs_wordpressFeed_sm_jpg from '../images/excellusbcbs-wordpress-feed@sm.jpg';
import excellusbcbs_wordpressFeed_md_jpg from '../images/excellusbcbs-wordpress-feed@md.jpg';
import excellusbcbs_wordpressFeed_lg_jpg from '../images/excellusbcbs-wordpress-feed@lg.jpg';

import portrait_sm_jpg from '../images/portrait-bw@sm.jpg';

import react_dashboard_xs_jpg from '../images/react-dashboard@xs.jpg';
import react_dashboard_md_jpg from '../images/react-dashboard@md.jpg';
// import react_dashboard_lg_jpg from '../images/react-dashboard@lg.jpg';

import react_view_today_sm_jpg from '../images/react-view-today@sm.jpg';
import react_view_today_md_jpg from '../images/react-view-today@md.jpg';
import react_view_today_lg_jpg from '../images/react-view-today@lg.jpg';

import shapes_preview_sm_gif from '../images/shapes-preview@sm.gif';
import shapes_preview_lg_gif from '../images/shapes-preview@lg.gif';

import univera_perks_xs_jpg from '../images/univerahealthcare-perks@xs.jpg';
import univera_perks_md_jpg from '../images/univerahealthcare-perks@md.jpg';
import univera_perks_lg_jpg from '../images/univerahealthcare-perks@lg.jpg';


var images = [
  {
    name: 'batman',
    src: {
      xs: batman_sm_jpg,
      sm: batman_md_jpg,
      md: batman_lg_jpg,
      lg: batman_xl_jpg,
    },
    project: true,
  },
  {
    name: 'career_areas',
    src: {
      xs: career_areas_lg_png,
      sm: career_areas_xl_png,
      md: career_areas_xl_png,
      lg: career_areas_xl_png,
    },
    project: false
  },
  {
    name: 'careers_screens',
    src: {
      xs: careers_screens_md_png,
      sm: careers_screens_md_png,
      md: careers_screens_lg_png,
      lg: careers_screens_xl_png,
    },
    project: true,
  },
  {
    name: 'comboSmash_highScores',
    src: {
      xs: comboSmash_highScores_xs_jpg,
      sm: comboSmash_highScores_md_jpg,
      md: comboSmash_highScores_md_jpg,
      lg: comboSmash_highScores_lg_jpg,
    },
    project: false
  },
  {
    name: 'comboSmash_gameplay',
    src: {
      xs: comboSmash_gameplay_xs_gif,
      sm: comboSmash_gameplay_md_gif,
      md: comboSmash_gameplay_md_gif,
      lg: comboSmash_gameplay_lg_gif,
    },
    project: false
  },
  {
    name: 'comboSmash_horde',
    src: {
      xs: comboSmash_horde_sm_jpg,
      sm: comboSmash_horde_sm_jpg,
      md: comboSmash_horde_md_jpg,
      lg: comboSmash_horde_lg_jpg,
    },
    project: false
  },
  {
    name: 'comboSmash_preview',
    src: {
      xs: comboSmash_preview_xs_jpg,
      sm: comboSmash_preview_sm_jpg,
      md: comboSmash_preview_md_jpg,
      lg: comboSmash_preview_lg_jpg,
    },
    project: true
  },
  {
    name: 'cycles',
    src: {
      xs: cycles_sm_jpg,
      sm: cycles_sm_jpg,
      md: cycles_md_jpg,
      lg: cycles_lg_jpg,
    },
    project: false
  },
  {
    name: 'cycles_gameover',
    src: {
      xs: cycles_gameover_sm_jpg,
      sm: cycles_gameover_sm_jpg,
      md: cycles_gameover_md_jpg,
      lg: cycles_gameover_lg_jpg,
    },
    project: false
  },
  {
    name: 'cycles_gameplay',
    src: {
      xs: cycles_gameplay_xs_gif,
      sm: cycles_gameplay_md_gif,
      md: cycles_gameplay_md_gif,
      lg: cycles_gameplay_lg_gif,
    },
    project: false
  },
  {
    name: 'cycles_start',
    src: {
      xs: cycles_start_xs_jpg,
      sm: cycles_start_md_jpg,
      md: cycles_start_md_jpg,
      lg: cycles_start_lg_jpg,
    },
    project: true
  },

  // Excellus images
  {
    name: 'excellusbcbs_app_page',
    src: {
      xs: excellusbcbs_app_page_xs_jpg,
      sm: excellusbcbs_app_page_sm_jpg,
      md: excellusbcbs_app_page_md_jpg,
      lg: excellusbcbs_app_page_lg_jpg,
    },
    project: true
  },
  {
    name: 'excellusbcbs_careers_calendar',
    src: {
      xs: excellusbcbs_careers_calendar_xs_png,
      sm: excellusbcbs_careers_calendar_sm_png,
      md: excellusbcbs_careers_calendar_md_png,
      lg: excellusbcbs_careers_calendar_lg_png,
    },
    project: false
  },
  {
    name: 'excellusbcbs_home_viewports',
    src: {
      xs: excellusbcbs_home_viewports_md_png,
      sm: excellusbcbs_home_viewports_md_png,
      md: excellusbcbs_home_viewports_lg_png,
      lg: excellusbcbs_home_viewports_lg_png,
    },
    project: false
  },
  {
    name: 'excellusbcbs_wordpressFeed',
    src: {
      xs: excellusbcbs_wordpressFeed_sm_jpg,
      sm: excellusbcbs_wordpressFeed_sm_jpg,
      md: excellusbcbs_wordpressFeed_md_jpg,
      lg: excellusbcbs_wordpressFeed_lg_jpg,
    },
    project: false,
  },
  {
    name: 'excellusbcbs_member',
    src: {
      xs: excellusbcbs_member_xs_jpg,
      sm: excellusbcbs_member_xs_jpg,
      md: excellusbcbs_member_md_jpg,
      lg: excellusbcbs_member_lg_jpg,
    },
    project: false
  },
  {
    name: 'portrait',
    src: {
      xs: portrait_sm_jpg,
    },
    project: false
  },
  {
    name: 'react_dashboard',
    src: {
      xs: react_dashboard_xs_jpg,
      sm: react_dashboard_xs_jpg,
      md: react_dashboard_md_jpg,
      lg: react_dashboard_md_jpg,
    },
    project: false
  },
  {
    name: 'react_view_today',
    src: {
      xs: react_view_today_sm_jpg,
      sm: react_view_today_sm_jpg,
      md: react_view_today_md_jpg,
      lg: react_view_today_lg_jpg
    },
    project: true,
  },
  {
    name: 'shapes_preview',
    src: {
      xs: shapes_preview_sm_gif,
      sm: shapes_preview_sm_gif,
      lg: shapes_preview_lg_gif,
    },
    project: true,
  },
  {
    name: 'univera_perks',
    src: {
      xs: univera_perks_xs_jpg,
      sm: univera_perks_xs_jpg,
      md: univera_perks_md_jpg,
      lg: univera_perks_lg_jpg
    },
    project: false,
  }
]


exports.images = function(breakpoints, window){
  let imageSize;
  let imagesSized = {};
  let imagesSrc = [];
  let imagesAll = {};
  let currentBreakpoint;

  let size = Object.keys(breakpoints);
  for(let i = 0; i < images.length; i++){
    let image = images[i];
    for(let s = size.length-1; s >= 0; s--){
      if(window >= breakpoints[size[s]]){
        currentBreakpoint = size[s];
        if(image.src[size[s]]){
          imagesSized[image.name] = image.src[size[s]];
          imagesSrc.push(image.src[size[s]]);
          s = 0;
        }
      }
    }
    imagesAll[image.name] = Object.assign({project: image.project},image.src);
  }
  return {
    sized: imagesSized,
    sources: imagesSrc,
    all: imagesAll,
    currentBreakpoint: currentBreakpoint
  }
}
